import {fetchListings as fListings} from './utils/listings';

const APIPATH = '/api/listings';

export const fetchListings = ({segmentKey}) => (dispatch, getState) => {
    const {
        destination: {
            details: {lbsId}
        }
    } = getState();

    const query = {id: lbsId};

    return fListings({
        dispatch,
        getState,
        segmentKey,
        query,
        apiPath: APIPATH
    });
};
